<script lang="ts" setup>
import { AppToggleLabel } from '@libs/ui';

interface SearchByMovingMapProps {
  searchByMovingMap: boolean;
  isLoading: boolean;
  isDisabled?: boolean;
}

const props = defineProps<SearchByMovingMapProps>();

interface SearchByMovingMapEmits {
  (eventName: 'toggle-search-by-moving-map', active: boolean): void;
}

const emit = defineEmits<SearchByMovingMapEmits>();
</script>

<template>
  <AppToggleLabel
    :is-loading="props.isLoading"
    :checked="props.searchByMovingMap"
    :is-disabled="props.isDisabled"
    @change="emit('toggle-search-by-moving-map', !props.searchByMovingMap)"
  >
    {{ $t('planner.search_when_moving_the_map') }}
  </AppToggleLabel>
</template>
